var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refund_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M19.7837 21.3336L19.1252 22.0862L19.7837 22.6624L20.4422 22.0862L19.7837 21.3336ZM5.68848 16.1253C5.68848 16.6776 6.13619 17.1253 6.68848 17.1253C7.24076 17.1253 7.68848 16.6776 7.68848 16.1253L5.68848 16.1253ZM13.1728 16.8779L19.1252 22.0862L20.4422 20.581L14.4898 15.3727L13.1728 16.8779ZM20.4422 22.0862L26.3946 16.8779L25.0776 15.3727L19.1252 20.581L20.4422 22.0862ZM20.7837 21.3336L20.7837 11.2146L18.7837 11.2146L18.7837 21.3336L20.7837 21.3336ZM5.68848 11.2146L5.68848 16.1253L7.68848 16.1253L7.68848 11.2146L5.68848 11.2146ZM13.2361 3.66695C9.06766 3.66695 5.68848 7.04614 5.68848 11.2146L7.68848 11.2146C7.68848 8.15071 10.1722 5.66695 13.2361 5.66695L13.2361 3.66695ZM20.7837 11.2146C20.7837 7.04614 17.4045 3.66695 13.2361 3.66695L13.2361 5.66695C16.3 5.66695 18.7837 8.15071 18.7837 11.2146L20.7837 11.2146Z",
    fill: "#A20000",
    fillOpacity: 0.992712
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.fc0e9f28ebcf01b3d611ba77ce30688f.svg";
export { ForwardRef as ReactComponent };